module.exports = __webpack_public_path__ + "img/12.316ff981.png";